import React, { useEffect, useState } from 'react';
import styles from './CouncilMemberCard.module.scss';
import InfoButton from '../../Atoms/InfoButton/InfoButton';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import { useNavigate } from 'react-router-dom';
import DeletePopup from '../Custom/DeletePopup';
import placeholderImage from '../../../assets/Imagess/no-image-found.jpg';
import { isEmpty } from 'lodash';
import newsUpdated from '../../../assets/Imagess/updated-member.png';
import MemberInfo from './MemberInfo';
import { useDeleteMember } from '../../../Hooks/Council';
import { useToast } from '../Custom/CustomToaster/Toast';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

function CouncilMemberCard({ data, refetch, selected }) {
  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showCheckmark, setShowCheckmark] = useState(false);
  const customizedToast = useToast();
  const {
    mutate: deleteMember,
    isLoading: isDeletingMember,
    isSuccess,
  } = useDeleteMember(data?.councilTeamId);

  const menuItems = [
    {
      label: 'تعديل',
      icon: editSvg,
      onClick: () => {
        navigate(
          `/home/edit-council-member/${
            'students' === selected
              ? 0
              : 'parents' === selected
              ? 1
              : 'cadets-students' === selected
              ? 2
              : 'faculty-members' === selected
              ? 3
              : 4
          }/${data?.councilTeamId}`
        );
      },
    },
    {
      label: 'Delete',
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];

  useEffect(() => {
    refetch();
  }, [isDeletingMember]);

  useEffect(() => {
    if (isSuccess) {
      // setShowCheckmark(true);
      customizedToast.open('تم الحذف بنجاح');
      setTimeout(() => {
        setShowCheckmark(false);
      }, 2000);
    }
  }, [isSuccess]);

  return (
    <div className={styles['news-card']}>
      {isEmpty(data?.teamImage) ? (
        <img src={placeholderImage} className={styles['news-card-image']} />
      ) : (
        <img
          src={sanitizeAndValidateUrl(`${data?.url}${data?.teamImage}`)}
          className={styles['news-card-image']}
          onClick={() => setShowInfo(true)}
        />
      )}
      <div className={styles['news-card-info']}>
        <div className={styles['row']}>
          <InfoButton
            icon={moreInfo}
            className={styles['more-info']}
            data={menuItems}
          />
          <div>
            <p className={styles['key']}>Name</p>
            <p className={styles['value']}>{data?.fullName_EN}</p>
            <p className={styles['key']}>Position</p>
            <p className={styles['value']}>
              {!isEmpty(data?.position_DisplayEN)
                ? data?.position_DisplayEN
                : '-'}
            </p>
            <p className={styles['key']}>Member Category</p>
            <p className={styles['value']}>
              {!isEmpty(data?.category_DisplayEN)
                ? data?.category_DisplayEN
                : '-'}
            </p>
          </div>
        </div>
      </div>
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title="عضو الفريق"
          handleDelete={() => {
            deleteMember();
            setShowDeletePopup(false);
          }}
          isLoading={isDeletingMember}
        />
      )}
      {showInfo && (
        <MemberInfo
          data={data}
          handleOnClose={() => setShowInfo(false)}
          setShowDeletePopup={setShowDeletePopup}
          selected={selected}
        />
      )}
      {showCheckmark && (
        <div className={styles['checkmark']}>
          <img src={newsUpdated} />
        </div>
      )}
    </div>
  );
}

export default CouncilMemberCard;
